import { useEffect, useRef } from "react";
import QRCode from "qrcode";
import { smsDeepLink } from "../api";

interface Props {
  inboundNumber: string | undefined;
  body: string;
}

export function isMobile(): boolean {
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

export function SmsQrCode({ inboundNumber, body }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const href = smsDeepLink(inboundNumber, body);

  useEffect(() => {
    if (!href || !canvasRef.current) return;
    QRCode.toCanvas(canvasRef.current, href, {
      width: 200,
      margin: 2,
      color: { dark: "#000000", light: "#ffffff" },
    });
  }, [href]);

  if (!href) return null;

  return (
    <div className="sms-qr">
      <p className="muted" style={{ marginBottom: 8 }}>
        Telefonunuzla QR kodu okutun, SMS uygulaması açılacak:
      </p>
      <canvas ref={canvasRef} style={{ display: "block", margin: "0 auto", borderRadius: 8 }} />
    </div>
  );
}
